import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection } from "@/components/legal/LegalProse";
import { OperatorContact } from "@/components/legal/OperatorContact";
import { OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

const POLICIES = [
  { to: "/privacy", title: "Privacy Policy", desc: "Data we collect, DPDP rights, retention." },
  { to: "/TermsandConditions", title: "Terms and Conditions", desc: "User agreement and liability." },
  { to: "/RefundandCancellation", title: "Refund and Cancellation", desc: "Refunds and subscription cancellation." },
  { to: "/guidelines", title: "Community Guidelines", desc: "Content rules and enforcement." },
  { to: "/child-safety", title: "Child safety", desc: "CSAE policy and reporting." },
  { to: "/copyright", title: "Copyright & IP", desc: "Takedown and counter-notice." },
  { to: "/payments", title: "Payments", desc: "Direct INR tips, subs, unlocks (Cashfree)." },
  { to: "/ads", title: "Advertising", desc: "AdMob disclosure." },
  { to: "/data-deletion", title: "Data deletion", desc: "Delete account and data." },
  { to: "/cookies", title: "Cookies", desc: "Web cookies and local storage." },
  { to: "/ContactUs", title: "Contact Us", desc: "Support emails and phone." },
  { to: "/faq", title: "FAQ", desc: "Product help." },
] as const;

export function LegalHubPage() {
  return (
    <LegalLayout
      title="Legal"
      subtitle={`Policies and notices for ${OPERATOR.product}.`}
    >
      <LegalSection title="Operator">
        <OperatorContact />
      </LegalSection>

      <LegalSection title="Documents">
        <ul className="divide-y divide-border rounded-2xl border border-border dark:divide-dark-border dark:border-dark-border">
          {POLICIES.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                className="block px-4 py-3.5 transition hover:bg-black/[0.03] dark:hover:bg-white/[0.04] sm:px-5"
              >
                <span className="font-semibold text-ink dark:text-dark-ink">
                  {item.title}
                </span>
                <span className={`mt-0.5 block text-sm ${tw.muted}`}>{item.desc}</span>
              </Link>
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection title="Governing law">
        <LegalP>
          Unless stated otherwise, {OPERATOR.product} policies are governed by the laws of India.
          Operator: {OPERATOR.name}, Kadapa District, Andhra Pradesh.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
